import { useEffect, useRef, useState } from "react";

import { Checkbox, Modal } from "@king-ict/eupisi-ui/components";
import { KindergartenRoleEnum } from "@king-ict/eupisi-ui/models";
import { useTranslation } from "react-i18next";

import {
  getInstitutionInitialConversationEnabled,
  putInstitutionInitialConversationEnabled,
} from "../../api/kindergartenApi";
import { useTypedSelector } from "../../app";
import { AdministrationListHeader } from "../../components";
import { useBusinessRule } from "../../hooks";
import styles from "./InitialConversation.module.scss";

export default function InitialConversation() {
  const { t } = useTranslation();
  const { canInitialConversationEnabledUpdate } = useBusinessRule();
  const [
    initialConversationEnabled,
    setInitialConversationEnabled,
  ] = useState<boolean>(false);
  const user = useTypedSelector((state) => state.application.user);
  const [isMessageModalOpened, setIsMessageModalOpened] = useState<boolean>(
    false
  );
  const initialConversationEnabledNewValue = useRef<boolean>(
    initialConversationEnabled
  );

  useEffect(() => {
    (async () => {
      const getInstitutionInitialConversationEnabledResult = await getInstitutionInitialConversationEnabled();
      setInitialConversationEnabled(
        getInstitutionInitialConversationEnabledResult
      );
    })();
  }, []);

  const handleInitialConversationCheckBoxClick = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { checked } = e.target;
    initialConversationEnabledNewValue.current = checked;
    setIsMessageModalOpened(true);
  };

  const handleConfirmMessageModal = () => {
    setInitialConversationEnabled(initialConversationEnabledNewValue.current);
    (async () => {
      await putInstitutionInitialConversationEnabled(
        initialConversationEnabledNewValue.current
      );
      setIsMessageModalOpened(false);
    })();
  };

  const handleToggleMessageModal = () => {
    setIsMessageModalOpened(!isMessageModalOpened);
  };

  return (
    <>
      {user.roleId === KindergartenRoleEnum.GroupEnrollmentCriterionAdmin && (
        <>
          <AdministrationListHeader
            infoMessage={t(
              "request.initialConversation.mainInfoMessageAdminCriteria"
            )}
            title={t("sidebar.initialConversationTitle")}
          />
        </>
      )}
      {user.roleId !== KindergartenRoleEnum.GroupEnrollmentCriterionAdmin && (
        <>
          <AdministrationListHeader
            infoMessage={t("request.initialConversation.mainInfoMessage1")}
            title={""}
          />
          <AdministrationListHeader
            infoMessage={t("request.initialConversation.mainInfoMessage2")}
            title={t("sidebar.initialConversationTitle")}
          />
        </>
      )}
      <Checkbox
        label={t("request.initialConversation.adminCheckboxMessage")}
        checked={initialConversationEnabled}
        onChange={(e) => handleInitialConversationCheckBoxClick(e)}
        disabled={canInitialConversationEnabledUpdate() === false}
      />
      <Modal
        type={"confirm"}
        title={t("request.initialConversation.confirmSendTitle")}
        cancelText={t("common.no")}
        confirmText={t("common.yes")}
        open={isMessageModalOpened}
        onConfirm={handleConfirmMessageModal}
        onClose={handleToggleMessageModal}
      >
        <div className={styles.modalMessageContent}>
          {initialConversationEnabledNewValue.current
            ? t("request.initialConversation.confirmSendEnable")
            : t("request.initialConversation.confirmSendDisable")}
        </div>
      </Modal>
    </>
  );
}
